export interface ResponseDTO {}
